import React from "react";
import MuiAvatar from "@mui/material/Avatar";

type Props = {
  name: string;
  size?: "small" | "large";
};

export function Avatar({ name, size = "small" }: Props) {
  return <MuiAvatar {...stringAvatar(name, size)} />;
}

const COLORS = ["#4f46e5", "#0891b2", "#7c3aed", "#0d9488", "#c026d3", "#ea580c", "#059669", "#dc2626"];

function stringToColor(string: string) {
  let j = 0;

  for (let i = 0; i < string.length; i++) {
    j += string.charCodeAt(i);
    j %= COLORS.length;
  }

  return COLORS[j];
}

function getAbbreviation(name: string) {
  return name
    .trim()
    .split(" ")
    .map((word) => word[0].toUpperCase())
    .slice(0, 2)
    .join("");
}

function stringAvatar(name: string, size: "small" | "large") {
  const sizeStyle =
    size === "small"
      ? {
          width: "24px",
          height: "24px",
          fontSize: "12px",
        }
      : {
          width: "32px",
          height: "32px",
          fontSize: "14px",
        };

  return {
    sx: {
      ...sizeStyle,
      bgcolor: stringToColor(name),
      color: "common.white",
    },
    children: getAbbreviation(name),
  };
}
